import React, {useEffect, useState} from 'react'
import {useHistory} from "react-router-dom";
import '../base/Theme.css';
import './Login.css';
import firebase from 'firebase/app';
import 'firebase/auth';
import Input from "../base/input/Input";
import Button from "../base/button/Button";
import Note from "../base/note/Note";
import Loader from "../base/loader/Loader";
import Toolbar from "../base/toolbar/Toolbar";
import {showError, showSuccess} from "../base/toaster/CustomToaster";
import Space from "../base/space/Space";
import Back from "../base/back/Back";
import {isDevEnv} from "../../utils/Environment";
import {createWallet} from "../../data/Api";

function Login() {
    const history = useHistory();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(true);

    let stopAuthListener;

    useEffect(() => {
        checkLogin();
    }, [])

    const checkLogin = () => {
        setLoading(true)
        stopAuthListener = firebase.auth().onAuthStateChanged(function (user) {
            if (user) history.replace("/lobby");
            setLoading(false);

            stopAuthListener();
        });
    }

    const onEmailChanged = (email) => {
        setEmail(email);
    }

    const onPasswordChanged = (password) => {
        setPassword(password);
    }

    const onLoginClick = async () => {
        try {
            setLoading(true);
            const userCredentials = await firebase.auth().signInWithEmailAndPassword(email, password);
            if (!userCredentials.user.emailVerified && !isDevEnv()) {
                await userCredentials.user.sendEmailVerification();
                await firebase.auth().signOut();

                showError("Your account is not verified. Find a verification email in your inbox.")
            } else {
                createPlayerWallet()
            }
        } catch (e) {
            showError(e.message);
            setLoading(false);
        }
    }

    const createPlayerWallet = async () => {
        try {
            setLoading(true);
            await createWallet();
            history.replace("/lobby");
        } catch (e) {
            await firebase.auth().signOut();
            setLoading(false);
            showError("Failed to create wallet.")
        }
    }

    const onPasswordResetClick = async () => {
        try {
            setLoading(true);
            await firebase.auth().sendPasswordResetEmail(email);
            showSuccess("Please check your inbox, we've sent you a password reset email.")
            setLoading(false);
        } catch (e) {
            showError(e.message);
            setLoading(false);
        }
    }

    const onSignUpClick = () => {
        history.push("/register");
    }

    if (loading) {
        return <div className={"Root"}><Loader/></div>
    }

    return (
        <div className="Root">
            <div className="Content">
                <Toolbar title={"Log in"} leftButton={<Back/>}/>
                <Input type="text" placeholder={"Email"} text={email} onTextChanged={onEmailChanged}
                       onEnterPressed={onLoginClick}/>
                <Space space={8}/>
                <Input type="password" placeholder={"Password"} text={password} onTextChanged={onPasswordChanged}
                       onEnterPressed={onLoginClick}/>
                <Space space={32}/>
                <Button text={"Log in"} onClick={onLoginClick}/>
                <Space space={16}/>
                <Note text={"Don't have an account yet?"} link={"Sign up"} onClick={onSignUpClick}/>
                <Note text={"Forgot a password?"} link={"Reset"} onClick={onPasswordResetClick}/>
            </div>
        </div>
    );
}

export default Login;
